import React from "react";
import { Button } from "../Button";

export type EventTabKey = string;

interface EventTabsProps {
  activeTab: EventTabKey;
  onChange: (tab: EventTabKey) => void;
  tabs: { key: EventTabKey; label: string; short_label: string }[];
}

export const EventTabs: React.FC<EventTabsProps> = ({ activeTab, onChange, tabs }) => {
  return (
    <div className="flex overflow-x-auto gap-2 mt-6 pb-1">
      {tabs.map((tab) => (
        <Button
          key={tab.key}
          variant={activeTab === tab.key ? "primary" : "secondary"}
          size="sm"
          className="whitespace-nowrap"
          onClick={() => onChange(tab.key)}
        >
          <span className="hidden md:inline">{tab.label}</span>
          <span className="md:hidden">{tab.short_label}</span>
        </Button>
      ))}
    </div>
  );
};
